import { Component, input, output, signal, OnInit, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface PeriodOption {
  value: number;
  label: string;
}

@Component({
  selector: 'app-period-selector',
  imports: [CommonModule],
  templateUrl: './period-selector.html',
  styleUrl: './period-selector.scss',
})
export class PeriodSelector implements OnInit {
  options = input<PeriodOption[]>([]);
  initialValue = input<number | null>(null);
  selectedValue = signal<number | null>(null);
  
  // Output para emitir el valor seleccionado
  valueChange = output<number>();

  constructor() {
    // Usar effect para reaccionar a cambios en initialValue
    effect(() => {
      const initial = this.initialValue();
      if (initial !== null && this.selectedValue() === null) {
        this.selectedValue.set(initial);
      }
    });
  }

  ngOnInit() {
    // Si hay un valor inicial, seleccionarlo
    const initial = this.initialValue();
    if (initial !== null) {
      this.selectedValue.set(initial);
    } else if (this.options().length > 0) {
      // Si no hay valor inicial, seleccionar el primero por defecto
      this.selectedValue.set(this.options()[0].value);
      this.valueChange.emit(this.options()[0].value);
    }
  }

  selectOption(value: number) {
    this.selectedValue.set(value);
    this.valueChange.emit(value);
  }

  isSelected(value: number): boolean {
    return this.selectedValue() === value;
  }
}
